import { supabase } from "@/integrations/supabase/client";

/**
 * Generate a unique event_id shared between browser pixel and server event
 * for TikTok deduplication.
 */
function generateEventId(): string {
  return crypto.randomUUID();
}

/**
 * Fire a TikTok event both client-side (pixel) and server-side (Events API).
 * The same event_id is used for deduplication.
 */
export async function trackTikTokEvent(
  event: "ViewContent" | "AddToCart" | "InitiateCheckout" | "CompletePayment",
  params: {
    value?: number;
    currency?: string;
    content_id?: string;
    content_type?: string;
    phone?: string;
  } = {}
) {
  const eventId = generateEventId();
  const url = window.location.href;

  // 1. Browser pixel (client-side) — fire & forget
  try {
    const ttq = (window as any).ttq;
    if (ttq) {
      ttq.track(event, {
        value: params.value,
        currency: params.currency || "USD",
        content_id: params.content_id,
        content_type: params.content_type || "product",
        event_id: eventId,
      });
    }
  } catch (e) {
    console.warn("TikTok pixel track failed:", e);
  }

  // 2. Server-side — send via edge function
  try {
    await supabase.functions.invoke("tiktok-event", {
      body: {
        event,
        event_id: eventId,
        url,
        value: params.value,
        currency: params.currency || "USD",
        content_id: params.content_id,
        content_type: params.content_type || "product",
        phone: params.phone,
      },
    });
  } catch (e) {
    console.warn("TikTok server event failed:", e);
  }
}
